import { IModuleOption, ModuleOption } from './module-option';

export interface IModuleI18n {
	readonly name: string;
	readonly title: string;
	readonly locale: string;
	readonly videoId: string;
	readonly description: string;
	readonly suggestionText: string;
	readonly averageDuration?: string;
	readonly options: ReadonlyArray<IModuleOption>;
}

export class ModuleI18n implements IModuleI18n {
	private _name: string;
	private _title: string;
	private _locale: string;
	private _videoId: string;
	private _description: string;
	private _suggestionText: string;
	private _averageDuration?: string;
	private _options: ModuleOption[];

	constructor(
		name: string,
		title: string,
		locale: string,
		videoId: string,
		description: string,
		suggestionText: string,
		averageDuration: string,
		options: ModuleOption[]
	) {
		this._name = name;
		this._title = title;
		this._locale = locale;
		this._videoId = videoId;
		this._description = description;
		this._suggestionText = suggestionText;
		this._averageDuration = averageDuration;
		this._options = options;
	}

	public get averageDuration(): string {
		return this._averageDuration;
	}

	public get name(): string {
		return this._name;
	}

	public get title(): string {
		return this._title;
	}

	public get locale(): string {
		return this._locale;
	}

	public get videoId(): string {
		return this._videoId;
	}

	public get description(): string {
		return this._description;
	}

	public get suggestionText(): string {
		return this._suggestionText;
	}

	public get options(): ModuleOption[] {
		return this._options;
	}
}
